export const PRIORITIES = [
  { v: "urgent", l: "Urgent", c: "bg-red-600 text-white" },
  { v: "high", l: "High", c: "bg-orange-500 text-white" },
  { v: "medium", l: "Medium", c: "bg-amber-400 text-slate-900" },
  { v: "low", l: "Low", c: "bg-slate-300 text-slate-700" },
];
export const priorityRank = (p) => ({ urgent: 0, high: 1, medium: 2, low: 3 }[p] ?? 2);

export function PriorityBadge({ priority, testid }) {
  const p = PRIORITIES.find((x) => x.v === (priority || "medium")) || PRIORITIES[2];
  return <span data-testid={testid} className={`text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${p.c}`}>{p.l}</span>;
}

export function PrioritySelect({ value, onChange, testid, className = "" }) {
  return (
    <select data-testid={testid} value={value || "medium"} onChange={(e) => onChange(e.target.value)}
      className={`h-10 border-2 border-slate-300 rounded px-2 text-sm ${className}`}>
      {PRIORITIES.map((p) => <option key={p.v} value={p.v}>{p.l}</option>)}
    </select>
  );
}
